import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
    apiUrlCH: 'https://api-ch.mowa.com',
    apiUrlDE: 'https://api-de.mowa.com',
    cmsApiUrl: 'https://cms.mowa.com'
};
